<div class="contact-sales-skeleton">
  <div class="contact-sales-skeleton-content" aria-hidden="true">
    <div class="contact-sales-skeleton-intro">
      <wp-skeleton class="-title" height="36px" [width]="'52%'" [loading]="true"></wp-skeleton>
      <wp-skeleton height="18px" [width]="'100%'" [loading]="true"></wp-skeleton>
      <wp-skeleton height="18px" [width]="'92%'" [loading]="true"></wp-skeleton>
      <wp-skeleton height="18px" [width]="'78%'" [loading]="true"></wp-skeleton>
    </div>

    <div class="contact-sales-skeleton-paragraph">
      <wp-skeleton height="18px" [width]="'100%'" [loading]="true"></wp-skeleton>
      <wp-skeleton height="18px" [width]="'88%'" [loading]="true"></wp-skeleton>
    </div>

    <div class="contact-sales-skeleton-paragraph -short">
      <wp-skeleton height="18px" [width]="'76%'" [loading]="true"></wp-skeleton>
      <wp-skeleton height="18px" [width]="'58%'" [loading]="true"></wp-skeleton>
    </div>

    <div class="contact-sales-skeleton-checklist">
      <div class="contact-sales-skeleton-checklist-item">
        <span class="contact-sales-skeleton-check" aria-hidden="true">
          <wp-skeleton height="18px" [width]="'18px'" [loading]="true"></wp-skeleton>
        </span>
        <wp-skeleton height="18px" [width]="'88%'" [loading]="true"></wp-skeleton>
      </div>
      <div class="contact-sales-skeleton-checklist-item">
        <span class="contact-sales-skeleton-check" aria-hidden="true">
          <wp-skeleton height="18px" [width]="'18px'" [loading]="true"></wp-skeleton>
        </span>
        <wp-skeleton height="18px" [width]="'80%'" [loading]="true"></wp-skeleton>
      </div>
      <div class="contact-sales-skeleton-checklist-item">
        <span class="contact-sales-skeleton-check" aria-hidden="true">
          <wp-skeleton height="18px" [width]="'18px'" [loading]="true"></wp-skeleton>
        </span>
        <wp-skeleton height="18px" [width]="'84%'" [loading]="true"></wp-skeleton>
      </div>
    </div>

    <div class="contact-sales-skeleton-card">
      <wp-skeleton height="160px" [width]="'100%'" [loading]="true"></wp-skeleton>
    </div>
  </div>

  <div class="contact-sales-form-wrapper">
    <app-contact-sales-form-skeleton-loader></app-contact-sales-form-skeleton-loader>
  </div>
</div>
